import service from "../../services/common.service";
/**
 * toggle channels menu
 * @param {*} event 
 */
function toggleMenu(event=""){
    var dgElement = document.getElementById("digital-gate");
    var adminCheck = dgElement.getElementsByClassName("adminToggle")[0];
    if(event=="show"){
        adminCheck.checked = true;
    }
    if(event=="hide"){
        adminCheck.checked = false;
    }
    if(event==""){
        adminCheck.checked = !adminCheck.checked;
        saveLog(adminCheck.checked);
    }
}
/**
 * save log
 * @param {*} display 
 */
function saveLog(display){
    var accountKey = window.dgAccountKey;
    var eventLog = { "channel": "floating btn", "evento": "", "status": "success" };
    if(display){
        eventLog["evento"] = "Open digitalgate";
    }else{
        eventLog["evento"] = "Close digitalgate";
    }
    
    service.saveEventLog(eventLog,accountKey);
}

if(!window.floatingButton){
    window.floatingButton = {};
}

window.floatingButton["toggleMenu"] = toggleMenu;